import { ContentSection as HygraphContentSectionProps } from '@/lib/types';

import ContentSection from '@/components/content-section';

import contentSectionTransformer from '@/hygraph/transformers/content-section.transformer';

export default function ContentSectionRenderer(props: unknown) {
  const hygraphProps = props as HygraphContentSectionProps;
  const componentProps = contentSectionTransformer(hygraphProps);

  return <ContentSection {...componentProps} />;
}
